import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/close.png'


const _hoisted_1 = { class: "accordion__answer" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("p", _hoisted_1, [
    _createElementVNode("span", null, [
      _createElementVNode("span", null, _toDisplayString(_ctx.words?.english), 1),
      (_ctx.words?.enValues != null && _ctx.words.enValues.length > 0)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, ", "))
        : _createCommentVNode("", true)
    ]),
    (_ctx.words?.enValues != null)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.words.enValues, (enWords, index) => {
            return (_openBlock(), _createElementBlock("span", { key: index }, [
              _createElementVNode("span", null, _toDisplayString(enWords), 1),
              (index != _ctx.words.enValues.length - 1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, ", "))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("img", {
      src: _imports_0,
      alt: "close",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.deleteAnswer(_ctx.words.english)))
    })
  ]))
}